import { GridColTypeDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";

import baseColumn from "./BaseColumn";
import { fieldLabelFormat } from "../TableUtils";

export interface DateTimeOptions {
  headerLabels?: Record<string, string>;
}

function dateTimeColumn(options?: DateTimeOptions): GridColTypeDef {
  const dateTimeColumn: GridColTypeDef = {
    ...baseColumn,
    type: "dateTime",
    renderCell: (params: GridRenderCellParams) => {
      return (
        <Tooltip title={params.formattedValue}>
          <span>{params.formattedValue}</span>
        </Tooltip>
      )
    }
  };
  if (options?.headerLabels) {
    dateTimeColumn.renderHeader = fieldLabelFormat(options.headerLabels);
  }
  return dateTimeColumn;
}

export default dateTimeColumn;